<template>
<div class="how_to_play">
  <div class="title">Welcome to <br class="sp">Get24!!</div>
  <div class="description">
    <div>This is a trading card raffle that can be played with small amounts of money!</div>
    <div>Letʼs challenge the lottery for the card you want!</div>
    <div class="sub_title">You can win one of the “Card list”!</div>
    <img class="card_list" src="/img/how_to_play/how_to_play_bar.png">
    <img class="gacha left_gacha" src="/img/how_to_play/howto03.png" alt="howto03">
    <img class="gacha right_gacha" src="/img/how_to_play/howto04.png" alt="howto04">
    <img class="card left_card" src="/img/how_to_play/howto05.png" alt="howto05">
    <img class="card right_card" src="/img/how_to_play/howto06.png" alt="howto06">
    <div class="note card_list">An example</div>
  </div>
  <HowToPlayDescription class="step1" step="Step,1" title="Register as a new member with Get24!">
    <template v-slot:default>
      <div class="how_to_play_description_text">Receive 500 points for new member <br class="sp">registration campaign</div>
      <div class="how_to_play_description_text">(Applicable to residents outside of Japan)</div>
      <div class="step1_content flex">
        <img class="handshake pc" src="/img/how_to_play/howto08.png" alt="howto08">
        <div class="step1_content_text">
          <div class="how_to_play_description_text ">【About the Refer-a-Friend Campaign】
            <div class="img_area">
              <img class="handshake sp_inline" src="/img/how_to_play/howto08.png" alt="howto08">
              <img class="coin" src="/img/how_to_play/howto09.png" alt="howto09">
            </div>
          </div>
          <div class="how_to_play_description_text">You can introduce up to 10 friends only if <br class="sp">you have completed SMS authentication and </div>
          <div class="how_to_play_description_text">have made at least one payment on this site. After registration, if your friend completes </div>
          <div class="how_to_play_description_text">SMS authentication, both parties will receive 1000P.</div>
          <div class="how_to_play_description_text">Referrer's My Page referral code <br class="sp">must be entered at the time of registration</div>
        </div>
      </div>
    </template>
  </HowToPlayDescription>
  <HowToPlayDescription class="step2" step="Step,2" title="Buy points!">
    <template v-slot:default>
      <div class="how_to_play_description_text">You can purchase points with these payment methods</div>
      <div class="img_area">
        <img class="coin" src="/img/how_to_play/howto10.png" alt="howto10">
        <img class="pay" src="/img/how_to_play/howto11.png" alt="howto11">
      </div>
    </template>
  </HowToPlayDescription>
  <HowToPlayDescription class="step3" step="Step,3" title="Choose lottery you want">
    <template v-slot:default>
      <div class="how_to_play_description_text">[title]</div>
      <div class="how_to_play_description_text">Yu-Gi-Oh, Pokémon, Weiß Schwarz and ONE PIECE</div>
      <div class="how_to_play_description_text">One card will be ejected at random</div>
      <div class="img_area">
        <img class="pc" src="/img/how_to_play/how_to_play_bar2.png" alt="how to play">
        <img class="sp" src="/img/how_to_play/howto20.png" alt="howto20">
        <img src="/img/how_to_play/howto13.png" alt="howto13">
      </div>
    </template>
  </HowToPlayDescription>
  <HowToPlayDescription class="step4" step="Step,4" title="Choose the card you want to receive!">
    <template v-slot:default>
      <div class="how_to_play_description_text">Exchange unwanted cards for points and receive only the cards you want.</div>
      <div class="img_area">
        <img class="pc" src="/img/how_to_play/howto14.png">
        <img class="sp" src="/img/how_to_play/howto21.png">
      </div>
    </template>
  </HowToPlayDescription>
  <HowToPlayDescription class="step5" step="Step,5" title="Let's raffle again!">
    <template v-slot:default>
      <div class="how_to_play_description_text">Use the points you get for exchanging cards <br class="sp">to win another raffle!</div>
    </template>
  </HowToPlayDescription>
  <HowToPlayDescription class="step6" step="Step,6" title="accumulate coin">
    <template v-slot:default>
      <div class="how_to_play_description_text">Play the lottery and save up coinsto exchange them for prizes</div>
      <div class="how_to_play_description_text">Earn 0.1 coins for every 100p spent.</div>
      <div class="img_area">
        <img src="/img/how_to_play/howto15.png">
      </div>
    </template>
  </HowToPlayDescription>
  <HowToPlayDescription class="step7" step="Step,7" title="Receive cards">
    <template v-slot:default>
      <div class="how_to_play_description_text">Be shipped by FedEx from Japan within 3-14 days.</div>
      <div class="how_to_play_description_text">
        <span>“free shipping”</span>
        <br class="sp">
        <span>※If you live in Japan, we ship by Yamato Transport.</span>
      </div>
      <div class="step7_content">
        <div class="how_to_play_description_text">【Post and get points Campaign】</div>
        <img class="sp_phone sp" src="/img/how_to_play/howto16.png">
        <div class="how_to_play_description_text">If you put the card you receive on everyone's record page on the site, you will receive 500 points!</div>
        <div class="img_area flex">
          <img class="phone pc" src="/img/how_to_play/howto16.png">
          <img class="post1" src="/img/how_to_play/howto17.png">
          <img class="post2" src="/img/how_to_play/howto18.png">
        </div>
      </div>
    </template>
  </HowToPlayDescription>
  <div class="end_sentence">Let’s enjoy Get24!!</div>
</div>

</template>
<script>
import HowToPlayDescription from '@/components/molecules/HowToPlayDescription.vue';

export default {
  name: 'HowToPlay',
  components: {
    HowToPlayDescription,
  },
};
</script>
<style lang="scss" scoped>
.how_to_play {
  color: #FFF;
  padding-top: 78px;
  .sp {
    display: none;
  }
  .sp_inline {
    display: none;
  }
  .pc_inline {
    display: block;
  }
  .pc {
    display: block;
  }
  .title {
    font-size: 40px !important;
    font-weight: bold;
    text-align: center;
    line-height: normal;
  }
  .description {
    margin-top: 60px;
    font-size: 22px;
    text-align: center;
    position: relative;
    .sub_title {
      margin: 80px 0 20px 0;
    }
    .card_list {
      width: 1224px;
    }
    .gacha {
      position: absolute;
      width: 120px;
    }
    .left_gacha {
      top: -110px;
      left: 23%;
    }
    .right_gacha {
      top: -110px;
      right: 23%;
    }
    .card {
      position: absolute;
      width: 140px;
    }
    .left_card {
      top: 10px;
      left: 12%;
    }
    .right_card {
      top: 10px;
      right: 12%;
      width: 160px;
    }
    .note {
      font-size: 16px;
      text-align: right;
      padding-right: 15px;
      margin: auto;
      }
    @media screen and (max-width: 1600px){
      .card_list {
        width: 100%;
      }
      .gacha {
        width: 95px;
      }
      .left_gacha {
        top: -170px;
        left: 23%;
      }
      .right_gacha {
        top: -170px;
        right: 23%;
      }
      .card {
        width: 105px;
      }
      .left_card {
        top: -70px;
        left: 10%;
      }
      .right_card {
        top: -70px;
        right: 10%;
        width: 125px;
      }
    }
  }
  .how_to_play_description_text {
    font-size: 22px;
  }
  .step1 {
    .step1_content {
      background-color: #3C4964;
      padding: 34px 14px;
      margin-top: 40px;
      img.handshake {
        width: 110px;
        height: 130px;
      }
      img.coin {
        width: 50px;
      }
      .step1_content_text {
        padding: 0 10px;
        .how_to_play_description_text:nth-child(1) {
          display: flex;
        }
        .how_to_play_description_text:nth-child(2) {
          font-weight: bold;
          padding-left: 20px;
          margin-top: 5px;
        }
        .how_to_play_description_text:nth-child(3) {
          font-weight: bold;
          padding-left: 20px;
        }
        .how_to_play_description_text:nth-child(4) {
          font-weight: bold;
          padding-left: 20px;
        }
        .how_to_play_description_text:nth-child(5) {
          padding-left: 20px;
          margin-top: 15px;
        }
      }
    }
  }
  .step2 {
    .img_area {
      display: flex;
      margin-top: 30px;
      img.coin {
        width: 330px;
        height: 220px;
      }
      img.pay {
        width: 330px;
        height: 192px;
        margin-left: 20px;
      }
    }
  }
  .step3 {
    .img_area {
      img {
        width: 100%;
        margin-top: 20px;
      }
    }
  }
  .step4 {
    .img_area {
      img {
        width: 100%;
        margin-top: 20px;
      }
    }
  }
  .step6 {
    .img_area {
      img {
        width: 750px;
        margin-top: 20px;
      }
    }
  }
  .step7 {
    .how_to_play_description_text {
      span:nth-child(3) {
        margin-left: 45px;
      }
    }
    .step7_content {
      background-color: #3C4964;
      padding: 34px 14px;
      margin-top: 40px;
      .how_to_play_description_text:nth-child(3) {
        margin-left: 30px;
      }
      .sp_phone {
        width: 100%;
        padding: 20px;
      }
      .img_area {
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 20px;
        img.phone {
          max-width: 340px;
          height: 260px;
          padding: 50px;
        }
        img.post1 {
          max-width: 287px;
          height: 267px;
        }
        img.post2 {
          max-width: 379px;
          height: 267px;
        }
      }
    }
  }
  .end_sentence {
    font-size: 40px;
    font-weight: bold;
    text-align: center;
    margin-top: 64px;
  }
}
@media screen and (max-width: 768px){
  .how_to_play {
    padding-top: 0;
    .sp {
      display: block;
    }
    .sp_inline {
      display: inline;
    }
    .pc {
      display: none;
    }
    .title {
      font-size: 33px !important;
    }
    .description {
      font-size: 16px;
      .sub_title {
        margin: 15px 0 10px 0;
      }
      .card_list {
        width: 100%;
      }
      .gacha {
        width: 50px;
      }
      .left_gacha {
        top: -105px;
        left: 16%;
      }
      .right_gacha {
        top: -105px;
        right: 16%;
      }
      .card {
        width: 60px;
      }
      .left_card {
        top: -160px;
        left: 1%;
      }
      .right_card {
        top: -160px;
        right: 1%;
        width: 75px;
      }
      .note {
        font-size: 16px;
        text-align: right;
        margin-right: 15px;
      }
    }
    .how_to_play_description_text {
      font-size: 16px;
    }
    .step1 {
      .step1_content  {
        .step1_content_text {
          padding: 0;
          .how_to_play_description_text:nth-child(1) {
            display: block;
            text-align: center;
            .img_area {
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding: 12px;
              img.handshake {
                width: 100px;
                height: auto;
              }
              img.coin {
                width: 100px;
              }
            }
          }
          .how_to_play_description_text:nth-child(2) {
            padding-left: 0;
          }
          .how_to_play_description_text:nth-child(3) {
            padding-left: 0;
          }
          .how_to_play_description_text:nth-child(4) {
            padding-left: 0;
          }
          .how_to_play_description_text:nth-child(5) {
            padding-left: 0;
          }
        }
      }
    }
    .step2 {
      .img_area {
        position: relative;
        img.coin {
          width: 145px;
          height: 97px;
          position: absolute;
          left: 50%;
        }
        img.pay {
          width: 280px;
          height: 163px;
        }
      }
    }
    .step6 {
      .img_area {
        img {
          width: 100%;
        }
      }
    }
    .step7 {
      .how_to_play_description_text {
        span:nth-child(3) {
          margin-left: 0;
        }
      }
      .step7_content {
        .how_to_play_description_text:nth-child(1) {
          text-align: center;
        }
        .how_to_play_description_text:nth-child(3) {
          margin-left: 0;
        }
        .img_area {
          img.post1 {
            max-width: 138px;
            height: 129px;
          }
          img.post2 {
            max-width: 183px;
            height: 129px;
          }
        }
      }
    }
    .end_sentence {
      font-size: 32px;
      margin-top: 30px;
    }
  }
}
.flex {
  display: flex;
}
</style>
